var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13L4 7L16 7L10 13Z",
    fill: "currentColor"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-delete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.196 20.021 5 19.55 5 19V6C4.71667 6 4.479 5.90433 4.287 5.713C4.09567 5.521 4 5.28333 4 5C4 4.71667 4.09567 4.479 4.287 4.287C4.479 4.09567 4.71667 4 5 4H9C9 3.71667 9.096 3.479 9.288 3.287C9.47933 3.09567 9.71667 3 10 3H14C14.2833 3 14.521 3.09567 14.713 3.287C14.9043 3.479 15 3.71667 15 4H19C19.2833 4 19.5207 4.09567 19.712 4.287C19.904 4.479 20 4.71667 20 5C20 5.28333 19.904 5.521 19.712 5.713C19.5207 5.90433 19.2833 6 19 6V19C19 19.55 18.8043 20.021 18.413 20.413C18.021 20.8043 17.55 21 17 21H7ZM9 16C9 16.2833 9.096 16.5207 9.288 16.712C9.47933 16.904 9.71667 17 10 17C10.2833 17 10.521 16.904 10.713 16.712C10.9043 16.5207 11 16.2833 11 16V9C11 8.71667 10.9043 8.479 10.713 8.287C10.521 8.09567 10.2833 8 10 8C9.71667 8 9.47933 8.09567 9.288 8.287C9.096 8.479 9 8.71667 9 9V16ZM13 16C13 16.2833 13.096 16.5207 13.288 16.712C13.4793 16.904 13.7167 17 14 17C14.2833 17 14.521 16.904 14.713 16.712C14.9043 16.5207 15 16.2833 15 16V9C15 8.71667 14.9043 8.479 14.713 8.287C14.521 8.09567 14.2833 8 14 8C13.7167 8 13.4793 8.09567 13.288 8.287C13.096 8.479 13 8.71667 13 9V16Z",
    fill: "currentColor"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3043 2.75 17.863 2.75C18.421 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.571 21.275 6.113C21.2917 6.65433 21.1083 7.11667 20.725 7.5L19.3 8.925ZM17.85 10.4L7.25 21H3V16.75L13.6 6.15L17.85 10.4Z",
    fill: "currentColor"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75H9.75V14.25H8.25Z",
    fill: "currentColor"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
    fill: "currentColor"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 1.66675C13.3066 1.66675 16.6666 5.02675 16.6666 9.16675C16.6666 13.3067 13.3066 16.6667 9.16663 16.6667C5.02663 16.6667 1.66663 13.3067 1.66663 9.16675C1.66663 5.02675 5.02663 1.66675 9.16663 1.66675ZM9.16663 15.0001C12.3891 15.0001 15 12.3892 15 9.16675C15 5.94341 12.3891 3.33341 9.16663 3.33341C5.94329 3.33341 3.33329 5.94341 3.33329 9.16675C3.33329 12.3892 5.94329 15.0001 9.16663 15.0001ZM16.2375 15.0592L18.595 17.4159L17.4158 18.5951L15.0591 16.2376L16.2375 15.0592Z",
    fill: "currentcolor"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkbox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM5 19H19V5H5V19Z",
    fill: "currentColor"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkbox-complete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM10.6 15.775C10.7333 15.775 10.8583 15.7543 10.975 15.713C11.0917 15.671 11.2 15.6 11.3 15.5L16.975 9.825C17.1583 9.64167 17.25 9.41667 17.25 9.15C17.25 8.88333 17.15 8.65 16.95 8.45C16.7667 8.26667 16.5333 8.175 16.25 8.175C15.9667 8.175 15.7333 8.26667 15.55 8.45L10.6 13.4L8.425 11.225C8.24167 11.0417 8.01667 10.95 7.75 10.95C7.48333 10.95 7.25 11.05 7.05 11.25C6.86667 11.4333 6.775 11.6667 6.775 11.95C6.775 12.2333 6.86667 12.4667 7.05 12.65L9.9 15.5C10 15.6 10.1083 15.671 10.225 15.713C10.3417 15.7543 10.4667 15.775 10.6 15.775Z",
    fill: "#212121",
    fillOpacity: 0.36
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-empty-state"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.440511 118.504C1.02786 117.917 1.98014 117.917 2.56749 118.504L12.7195 128.656C13.3068 129.244 13.3068 130.196 12.7195 130.783C12.1321 131.371 11.1799 131.371 10.5925 130.783L0.440511 120.631C-0.146837 120.044 -0.146837 119.092 0.440511 118.504Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.448 162.12C192.036 161.533 192.988 161.533 193.575 162.12L201.847 170.392C202.435 170.98 202.435 171.932 201.847 172.519C201.26 173.107 200.308 173.107 199.72 172.519L191.448 164.247C190.861 163.66 190.861 162.708 191.448 162.12Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.440511 130.784C1.02786 131.371 1.98014 131.371 2.56749 130.784L12.7195 120.632C13.3068 120.044 13.3068 119.092 12.7195 118.505C12.1321 117.917 11.1799 117.917 10.5925 118.505L0.440511 128.657C-0.146837 129.244 -0.146837 130.196 0.440511 130.784Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.448 172.519C192.036 173.107 192.988 173.107 193.575 172.519L201.847 164.247C202.435 163.66 202.435 162.708 201.847 162.12C201.26 161.533 200.308 161.533 199.72 162.12L191.448 170.392C190.861 170.98 190.861 171.932 191.448 172.519Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2872 0.440511C84.6999 -0.146837 83.7476 -0.146837 83.1602 0.440511C82.5729 1.02786 82.5729 1.98014 83.1602 2.56749L85.8568 5.26402L83.1603 7.96052C82.5729 8.54787 82.5729 9.50015 83.1603 10.0875C83.7476 10.6748 84.6999 10.6748 85.2872 10.0875L87.9837 7.391L90.6802 10.0875C91.2676 10.6748 92.2199 10.6748 92.8072 10.0875C93.3946 9.50014 93.3946 8.54786 92.8072 7.96051L90.1107 5.26402L92.8072 2.5675C93.3946 1.98015 93.3946 1.02787 92.8072 0.440519C92.2199 -0.146829 91.2676 -0.146829 90.6803 0.440519L87.9837 3.13704L85.2872 0.440511Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5443 69.936C17.7902 69.936 18.8003 68.926 18.8003 67.68C18.8003 66.4341 17.7902 65.424 16.5443 65.424C15.2983 65.424 14.2883 66.4341 14.2883 67.68C14.2883 68.926 15.2983 69.936 16.5443 69.936ZM16.5443 72.944C19.4515 72.944 21.8083 70.5872 21.8083 67.68C21.8083 64.7728 19.4515 62.416 16.5443 62.416C13.637 62.416 11.2803 64.7728 11.2803 67.68C11.2803 70.5872 13.637 72.944 16.5443 72.944Z",
    fill: "#6A9BD9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.6 184.992C133.261 184.992 134.608 183.645 134.608 181.984C134.608 180.323 133.261 178.976 131.6 178.976C129.939 178.976 128.592 180.323 128.592 181.984C128.592 183.645 129.939 184.992 131.6 184.992ZM131.6 188C134.923 188 137.616 185.306 137.616 181.984C137.616 178.661 134.923 175.968 131.6 175.968C128.277 175.968 125.584 178.661 125.584 181.984C125.584 185.306 128.277 188 131.6 188Z",
    fill: "#6A9BD9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.023 54.063C188.486 54.2799 188.385 54.9964 188.841 55.3528L198.592 62.971C199.048 63.3274 199.719 63.0564 199.8 62.4831L201.522 50.2298C201.602 49.6565 201.032 49.211 200.496 49.4279L189.023 54.063ZM197.999 53.6806L193.772 55.3883L197.365 58.195L197.999 53.6806Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9124 158.901C11.3756 159.118 11.2749 159.835 11.7311 160.191L20.1928 166.802C20.649 167.159 21.3199 166.888 21.4005 166.315L22.8951 155.681C22.9757 155.108 22.4055 154.662 21.8687 154.879L11.9124 158.901ZM19.3725 159.132L16.6621 160.227L18.9656 162.026L19.3725 159.132Z",
    fill: "#7CA9E2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 96.5,
    rx: 36,
    ry: 36.5,
    fill: "#D4E1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 51,
    stroke: "#6A9BD9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1774 66.9207C102.102 67.9083 107.599 70.6362 111.969 74.7572",
    stroke: "#6A9BD9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.879 76.7292C115.463 78.5214 116.83 80.4952 117.95 82.6092",
    stroke: "#6A9BD9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 41,
    stroke: "#6A9BD9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17 135.209L137.534 124.365L157.415 143.365C160.41 146.227 160.517 150.974 157.655 153.969C154.794 156.963 150.046 157.071 147.052 154.209L127.17 135.209Z",
    stroke: "#6A9BD9",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.ce12dbba2247b6e42b73f2d7e45f375f.svg";
export { ForwardRef as ReactComponent };